import {
  Bar,
  BarChart,
  CartesianGrid,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useEstadisticasStore } from "../../../../store/estadisticasStore";
import { getEstadisticasAbonadasHandler } from "../../../../handlers/estadisticasHandler";
import { useEffect } from "react";

const InfraccionesAbonadasPorMes = ({ estadisticas }) => {


  const { loads } = useGeneralAppStore();
  const { abonadas, } = useEstadisticasStore();
  useEffect(() => {
    if (!abonadas) {
      getEstadisticasAbonadasHandler();
    }
    return () => {
      useEstadisticasStore.setState({ abonadas: null })
    }
  }, [])

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            padding: "8px",
            color: "black",
            backgroundColor: "#A6B6F7",
            border: "1px solid #1334C9",
            borderRadius: "4px",
          }}
        >
          <span className="fw-bold">
            Infracciones abonadas el {payload[0]?.payload?.mes}:{" "}
            {payload[0]?.payload?.cantidad_recibos}
          </span>
        </div>
      );
    }

    return null;
  };

  const CustomLabel = ({ payload, x, y, width, height, value }) => {
    return (
      <text
        x={x + width / 2}
        y={y}
        textAnchor="middle"
        dy={-6}
        style={{ fontWeight: 600, color: "#1334C9" }}
      >{`Total: ${value}`}</text>
    );
  };
  // console.log(abonadas);

  return (
    <div>
      {loads.includes("estadisticas_abonadas") ? (
        <MuniSpinner2 />
      ) : (
        <div style={{ maxWidth: "1500px", height: "600px", position: "relative" }}>
          <h4 className="my-4 text-center"> Infracciones Abonadas por Mes </h4>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={abonadas}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="mes" interval="equidistantPreserveStart" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Bar
                name="Infracciones abonadas por mes"
                dataKey="cantidad_recibos"
                fill="#1134C9"
                activeBar={<Rectangle fill="#A6B6F7" stroke="#1134C9" />}
                label={<CustomLabel />}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default InfraccionesAbonadasPorMes;
